import React from 'react';
import { render } from 'react-dom';

import { ProviderWithGlobalStore } from 'tradera-state/configure-store';
import GdprContainer from 'tradera-components/alerts/gdpr/gpdr-container';

const GdprMount = initData => {
    if (initData.isNativeAppContext || initData.isHybridAppContext) {
        return;
    }
    const domNode = document.querySelector(
        '[data-component-cookie-notification]'
    );
    if (domNode) {
        render(
            <ProviderWithGlobalStore>
                <GdprContainer />
            </ProviderWithGlobalStore>,
            domNode
        );
    }
};

export default GdprMount;
